export default {"src":"/_next/static/media/fish-oil.24be374f.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};